<template>
    <swiper :slides-per-view="5" :space-between="30" :breakpoints="swiperBreakpoints" class="!h-full">
        <swiper-slide v-for="product in content" :key="'product-' + product.id">
            <product-card-vertical :product="product" />
        </swiper-slide>
    </swiper>
</template>

<script>
import { Swiper, SwiperSlide } from "swiper/vue"
import "swiper/swiper-bundle.min.css"
import ProductCardVertical from "@/components/molecules/ProductCardVertical"

export default {
    name: "ProductsSlider",
    props: ["content"],
    components: {
        ProductCardVertical,
        Swiper,
        SwiperSlide,
    },
    data() {
        return {
            swiperBreakpoints: {
                0: {
                    slidesPerView: 1,
                    spaceBetween: 20
                },
                // when window width is >= 480px
                480: {
                    slidesPerView: 2,
                    spaceBetween: 30
                },

                // when window width is >= 640px
                640: {
                    slidesPerView: 3,
                    spaceBetween: 40
                },
                // when window width is >= 480px
                1023: {
                    slidesPerView: 5,
                    spaceBetween: 30
                },
                1980: {
                    slidesPerView: 6.2,
                    spaceBetween: 60
                },
               
            }
           
        }

    },
}
</script>
